// extracted by mini-css-extract-plugin
export default {"_":"loginPage____+wlRL","wrapper":"loginPage_wrapper__yIGiG","input_box":"loginPage_input_box__7Nhu8","btn":"loginPage_btn__tJJse"};